module.exports = __webpack_public_path__ + "img/teachingmanagement_5.78bedcc2.jpg";